<template>
  <modal-wrapper
    ref="modalRef"
    :busy="okButtonBusy || cancelButtonBusy"
    :content-overflow-y="'visible'"
    :header="modalTitle"
    :ok-button-label="okButtonLabel"
    @hide="cleanModal()"
    @ok-button-click="emitSelectedOption"
    @show="getOptions()"
  >
    <styled-multiselect
      v-model="selectedOption"
      :options="options"
      :track-by="trackBy"
      :label="label"
      :loading="isLoadingOptions"
    />
  </modal-wrapper>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { sortStringsAlphabetically } from '@/helpers';
  import axios from 'axios';
  import StyledMultiselect from '../StyledMultiselect/StyledMultiselect.vue';
  import { useModalWrapper } from '../ModalWrapper';

  const props = defineProps<{
    modalTitle: string;
    okButtonLabel?: string;
    endpoint?: string;
    trackBy?: string;
    label?: string | Function;
    modalId?: string;
    okButtonBusy?: boolean;
    cancelButtonBusy?: boolean;
    preventClosingOnOk?: boolean;
    sortAlpabetically?: boolean;
  }>();

  const emit = defineEmits<{
    (e: 'option-selected', payload: any): void;
    (e: 'ok'): void;
  }>();

  const { modalRef, show, hide } = useModalWrapper();
  defineExpose({ show, hide });

  const options = ref<Record<string | number, any>[] | string[]>([]);
  const selectedOption = ref<Record<string | number, any> | undefined>(
    undefined,
  );
  const isLoadingOptions = ref<boolean>(false);

  async function getOptions() {
    if (!props.endpoint) {
      return;
    }

    isLoadingOptions.value = true;

    try {
      const response = await axios.get(props.endpoint);
      const optionsData = response.data;
      if (
        props.sortAlpabetically &&
        Array.isArray(optionsData) &&
        optionsData.every((element) => typeof element === 'string')
      ) {
        options.value = sortStringsAlphabetically(optionsData);
      } else {
        options.value = optionsData;
      }
    } catch {
      //
    }

    isLoadingOptions.value = false;
  }

  async function emitSelectedOption() {
    if (!selectedOption.value) {
      return;
    }

    emit('option-selected', selectedOption.value);
    emit('ok');

    if (!props.preventClosingOnOk) {
      hide();
    }
  }

  function cleanModal() {
    selectedOption.value = undefined;
  }
</script>
